import { getCurrentUserEmail } from '../auth';
import { getEightDInfoId } from '../eightDInfoStore';

const toIsoOrNull = (date) => {
  if (!date) return null;
  try {
    const d = date instanceof Date ? date : new Date(date);
    return isNaN(d.getTime()) ? null : d.toISOString();
  } catch {
    return null;
  }
};

export const buildD4Payload = ({
  responsiblePerson = '',
  plannedDate = null,
  achievedDate = null,
  occurrenceRows = [],
  nonDetectionRows = [],
  uploadedFiles = [],
  isDisabled = false,
  occurrenceToRemove = [],
  nonDetectionToRemove = [],
  attachmentsToRemove = [],
  currentUserEmail = getCurrentUserEmail(),
  d4Id = null,
  eightDInfoId = null,
}) => {
  const nowIso = new Date().toISOString();
  const finalEightDInfoId = eightDInfoId || getEightDInfoId();

  const OccurrenceResult = occurrenceRows.map((row, idx) => ({
    ...(row.id ? { D4OccurrenceId: Number(row.id) } : {}),
    EightDInfoId: finalEightDInfoId,
    Srno: idx + 1,
    Why: row.why || '',
    ProofAttachmentName: row.proofAttachmentName || '',
    AttachmentType: row.attachmentType || '',
    AttachmentData: row.attachmentData || '',
    CreatedBy: currentUserEmail,
    CreatedOn: nowIso,
  }));

  const NonDetectionDetails = nonDetectionRows.map((row, idx) => ({
    ...(row.id ? { D4NonDetectionId: Number(row.id) } : {}),
    EightDInfoId: finalEightDInfoId,
    Srno: idx + 1,
    Why: row.why || '',
    ProofAttachmentName: row.proofAttachmentName || '',
    AttachmentType: row.attachmentType || '',
    AttachmentData: row.attachmentData || '',
    CreatedBy: currentUserEmail,
    CreatedOn: nowIso,
  }));

  const Attachments = (uploadedFiles || []).filter(f => !f.isExisting).map((f) => {
    const base64Data = f.preview || '';
    const attachmentData = base64Data.startsWith('data:') ? base64Data : base64Data ? `data:${f.file?.type || 'image/jpeg'};base64,${base64Data}` : '';
    return {
      EightDInfoId: finalEightDInfoId,
      AttachmentName: f.file?.name || f.localPath || '',
      AttachmentType: f.file?.type || '',
      AttachmentData: attachmentData,
      CreatedBy: currentUserEmail,
      CreatedOn: nowIso,
    };
  });

  const payload = {
    ...(d4Id ? { D4Id: d4Id } : {}),
    EightDInfoId: finalEightDInfoId,
    ResponsiblePerson: responsiblePerson,
    PlannedDate: toIsoOrNull(plannedDate),
    AchievedDate: toIsoOrNull(achievedDate),
    CreatedBy: currentUserEmail,
    CreatedOn: nowIso,
    ModifiedBy: currentUserEmail,
    ModifiedOn: nowIso,
    IsDisabled: isDisabled,
    OccurrenceResult,
    NonDetectionDetails,
    Attachments,
    OccurrenceToRemove: occurrenceToRemove,
    NonDetectionToRemove: nonDetectionToRemove,
    AttachmentsToRemove: attachmentsToRemove,
  };

  return payload;
};
